require('./template/tab.html.js');
require('./template/tabset.html.js');
require('./tabs');

var MODULE_NAME = 'homepage.contentUI.tabs';

angular.module(MODULE_NAME, ['authoring.bootstrap.tabs', 'authoring/template/tabs/tab.html', 'authoring/template/tabs/tabset.html']);

module.exports = MODULE_NAME;



// WEBPACK FOOTER //
// ./app/common/tabs/index.js